const canvasSketch = require('canvas-sketch');
const random = require('canvas-sketch-util/random');
const seedRandom = require('seed-random');
const ohash = require('object-hash');
const alea = require('alea')
const rough = require('roughjs/bundled/rough.cjs.js')
const palettes = require('./automata-colors')

var seed, 
    seeded;

/**
  ooFrtxodbTGYLbh1mLYSK5JHuWqKYr2w9ofUVpucDiSduYbtg6N
  oocsJ2E4bSJoBxLy8dWtPYfgF6V5nnVkSKWcKJeYnHP9fMZwV7A
  ooRwmMc9MkjK32o2US3rhV4DYgvg1rmXsDvTFGqfDosJ9HmyD4T
  ooRTzHMH5132s5Ly8BagEYzW3c2QfYiZ7tQPt5VYPK7rgef9zLv
  ooj82KqHSjWjpozizZbhmBLStyeYTHJG2tXemDaJTfwTUhYtunt
  oo7wBAD1VbgtKs12AVy8S94trEyscqDSN1U6e2sQSQAPVjiM9FH
**/

const settings = {
  dimensions        : [ 600, 900 ],
  pixelsPerInch     : 500,
  pixelRatio        : 2,
  exportPixelRatio  : 10,
  scaleToFit        : true,
  scaleToFitPadding : 0,
  units             : 'px',
}

window.$fxhashFeatures = {}

function setFeature(key, value) {
  console.log(`Feature: ${key}: ${value}`)
  if (window.$fxhashFeatures[key] != undefined)
    window.$fxhashFeatures[key] += value
  else
    window.$fxhashFeatures[key] = value
}

// Helpsers

const rgbaColor = (c, opacity=1) => {
  return `rgba(${c[0]},${c[1]},${c[2]},${opacity})`
}

let c1, c2;
let _c1, _c2;
let colors, dotted;
const sketch = () => {
  return ({ canvas, context, width, height }) => {
    seed = window.fxhash || Math.random()*1000
    //seed = 'ooXYJPQbhw2Jwo9xChdZY4uv7CmTLbpCMj8ThGivekCRkFnTJXq'
    console.log('seed', seed)
    seedRandom(seed, { global: true })
    seeded = random.createRandom(seed)
    let _colors = seeded.pick(palettes)
    colors = _colors.palette
    setFeature('palette', _colors.name)
    let opacityLottery = seeded.range(0,10)
    if (opacityLottery >= 8) {
      dotted = true
      setFeature('grainy', true)
    } else {
      dotted = false 
      setFeature('grainy', false)
    }
    c1 = seeded.pick(colors) 
    c2 = seeded.pick(colors.filter(c => c != c1)) 
    _c1 = rgbaColor(c1, 1) 
    _c2 = rgbaColor(c2, 1)
    paintBackground(context, width, height)
    const frameWidth = 30
    let pixelSize = seeded.pick([0.5,1,1.5,2]) 
    let golLottery = seeded.range(0,10)
    setFeature('pixel-size', pixelSize)
    if (pixelSize >= 2 && golLottery >= 9 && !dotted) {
      let generations = Math.round(seeded.pick([100,200,500,1000]))
      setFeature('gol', true)
      setFeature('gol-generations', generations) 
      _c1 = rgbaColor(c1, seeded.range(0.2,0.8)) 
      _c2 = rgbaColor(c2, seeded.range(0.2,0.8)) 
      paintGameOfLife({ startX: 0, endX: width/pixelSize, startY: 0, endY: height/pixelSize, pixelSize, canvas, context, generations }) 
    } else {
      setFeature('gol', false)
      setFeature('gol-generations', 0)
    }
    paintLife({ context, startX: frameWidth, startY: frameWidth, height: height-frameWidth*2, pixelSize, _c1, _c2, frameWidth, width: width-frameWidth*2 })
    let negativeLottery = seeded.range(0,10)
    if (negativeLottery >= 9.5) {
      setFeature('negative', true)
      const negativesplit = seeded.pick(['vertical', 'horizontal', 'full'])
      setFeature('negative-split', negativesplit)
      createNegative({ context, canvas, negativesplit })
    } else {
      setFeature('negative', false)
      setFeature('negative-split', 'none')
    }
  }
}

function paintLife({ context, startX, startY, height, width, pixelSize, frameWidth }) {
    let rows = (height / pixelSize)
    let pixels = (width / pixelSize)
    let initialRow = Array.from(new Array(pixels)).map(i => seeded.pick([0,1]))
    let algoSwapLottery = Math.round(seeded.range(5,100))
    let algoSwap = Array.from(new Array(algoSwapLottery)).reduce((swaps, i) => {
      let index = Math.round(seeded.range(1,rows))
      let s = { index: index, flag: seeded.pick(['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eight']) }
      swaps[index] = s
      return swaps
    },{})
//    console.log(`====
//rows: ${rows}
//pixelSize: ${pixelSize}
//algoSwapLottery: ${algoSwapLottery}
//`)
    setFeature('algo-swaps', algoSwapLottery)
    let grid = [initialRow]
    let currentRow = null 
    let i = 0
    let genNextRow = generateNextRow.bind({ 
      first: seeded.pick([0,1]), 
      second: 0, 
      third: 1, 
      fourth: 1, 
      fifth: 0, 
      sixth: 1, 
      seventh: 0, 
      eight: 1 
    })
    while (grid.length < rows) {
      currentRow = grid[i]
      grid.push(genNextRow({ currentRow, swapAlgo: algoSwap[i], rowIndex: i }))
      i++
    }
    paintGrid({ context, grid, pixelSize, startX, startY })
}

function paintGameOfLife({ startX, endX, startY, endY, pixelSize, canvas, context, generations }) {
  let grid = generateGrid({ startX, endX, startY, endY })
  Array.from(new Array(generations)).forEach(() => {
    grid = updateCells({ grid })
  })
  drawCells({ canvas, ctx: context, grid, startX, startY, pixelSize })
}

function generateNextRow({ currentRow, swapAlgo, rowIndex }) {
  if (swapAlgo) {
    this[swapAlgo.flag] = this[swapAlgo.flag] ? 0 : 1 
    //console.log(this.first, this.second, this.third, this.fourth, this.fifth, this.sixth, this.seventh, this.eight)
  }
  const nextRow = currentRow.map((pixel, x) => {
    const prev_pixel = x > 0 ? currentRow[x-1] : seeded.pick([0,1])
    const next_pixel = x < currentRow.length-1 ? currentRow[x+1] : seeded.pick([0,1])
    const this_pixel = pixel
    let n = 0
    if (prev_pixel && this_pixel && next_pixel) n = this.first
    if (prev_pixel && this_pixel && !next_pixel) n = this.second
    if (prev_pixel && !this_pixel && !next_pixel) n = this.third 
    if (!prev_pixel && !this_pixel && !next_pixel) n = this.fourth
    if (!prev_pixel && !this_pixel && next_pixel) n = this.fifth
    if (!prev_pixel && this_pixel && next_pixel) n = this.sixth
    if (!prev_pixel && this_pixel && !next_pixel) n = this.seventh
    if (prev_pixel && !this_pixel && next_pixel) n = this.eight
    return n
  })
  return nextRow
}

function paintBackground(context, width, height) {
  context.beginPath()
  context.fillStyle = rgbaColor(seeded.pick(colors))
  context.fillRect(0,0, width, height)
  context.closePath()
}

function paintGrid({ context, grid, pixelSize, startX, startY }) {
  context.beginPath()
  grid.forEach((row,y) => {
    row.forEach((pixel,x) => {
      __c1 = dotted ? rgbaColor(c1, seeded.range(0.85,1)) : _c1
      __c2 = dotted ? rgbaColor(c2, seeded.range(0.85,1)) : _c2
      context.fillStyle = pixel ? __c1 : __c2 // if 1, color depending on x % 3 (or something)
      context.fillRect(startX+x*pixelSize,startY+y*pixelSize, pixelSize, pixelSize)
    })
  })
  context.closePath()
}

// GOL

// Create a grid of cells with random starting state
function generateGrid({ startX, endX, startY, endY }) {
  const grid = [];
  for (let i = startY; i < endY; i++) {
    const row = [];
    for (let j = startX; j < endX; j++) {
      row.push(Math.random() < 0.5)
    }
    grid.push(row);
  }
  return grid
}

// Function to update the state of each cell based on the state of its neighbors
function updateCells({ grid }) {
  const gridSize = grid.length
  const newGrid = [];
  grid.forEach((_row, i) => {
    const row = [];
    _row.forEach((pixel, j) => { 
      let aliveNeighbors = 0;
      for (let ni = -1; ni <= 1; ni++) {
        for (let nj = -1; nj <= 1; nj++) {
          if (ni === 0 && nj === 0) continue;
          if (grid[(i + ni + gridSize) % gridSize][(j + nj + gridSize) % gridSize]) {
            aliveNeighbors++;
          }
        }
      }
      // Use a simple rule to update the state of the cell
      if (aliveNeighbors === 3) {
        row.push(true)
      } else if (aliveNeighbors === 2) {
        row.push(pixel)
      } else {
        row.push(false)
      }
    })
    newGrid.push(row);
  })
  return newGrid;
}

function drawCells({ canvas, ctx, grid, pixelSize, startX, startY }) {
  ctx.beginPath()
  grid.forEach((row, i) => {
    row.forEach((pixel, j) => {
      if (pixel) {
        ctx.fillStyle = _c1;
      } else {
        ctx.fillStyle = _c2;
      }
      ctx.fillRect(startX+j*pixelSize, startY+i*pixelSize, pixelSize, pixelSize);
    })
  })
  ctx.closePath()
}

function createNegative({ context, canvas, negativesplit }) {
  let x=0
  let y=0
  let _width = canvas.width
  let _height = canvas.height
  if (negativesplit === 'vertical') _width = _width/2
  if (negativesplit === 'horizontal') _height = _height/2
  var imageData = context.getImageData(x, y, _width, _height);
  var dataArr = imageData.data;
  for(var i = 0; i < dataArr.length; i += 4)
  {
      var r = dataArr[i]; // Red color lies between 0 and 255
      var g = dataArr[i + 1]; // Green color lies between 0 and 255
      var b = dataArr[i + 2]; // Blue color lies between 0 and 255
      var a = dataArr[i + 3]; // Transparency lies between 0 and 255

      var invertedRed = 255 - r;
      var invertedGreen = 255 - g;
      var invertedBlue = 255 - b;

      dataArr[i] = invertedRed;
      dataArr[i + 1] = invertedGreen;
      dataArr[i + 2] = invertedBlue;
  }
  context.putImageData(imageData, x, y);
}

canvasSketch(sketch, settings);
